<template>
  <v-card class="elevation-3">
    <!--<v-card-title>-->
    <!--<div class="headline">-->
    <!--{{ header }}-->
    <!--</div>-->
    <!--</v-card-title>-->
    <v-card-text>
      <!--<div class="headline font-weight-bold">-->
      <!--{{ item }}-->
      <!--</div>-->
      <v-layout row>
        <div class="dHead">
          {{ header }}
        </div>
        <div class="vl"></div>
        <div class="dHead">
          {{ item }}
        </div>
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: ["header", "item"]
};
</script>

<style scoped>
.vl {
  margin-left: 10%;
  margin-right: 10%;
  border-left: 1px solid #757575;
}
.dHead {
  margin-left: 10px;
  color: #757575;
  font-size: 45px;
  text-align: center;
}
</style>
